import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { gamificationApi, readerApi } from '../services/api';
import './Footer.css';

const Footer = () => {
  const { isAuthenticated, user, preferences } = useAuth();
  const [userStats, setUserStats] = useState(null);
  const [, setLoading] = useState(false);

  // Load user stats when authenticated
  useEffect(() => {
    if (isAuthenticated && user && preferences?.competitiveMode) {
      loadUserStats();
    }
  }, [isAuthenticated, user, preferences?.competitiveMode]);

  const loadUserStats = async () => {
    try {
      setLoading(true);
      // Get the primary reader's stats
      const readersResponse = await readerApi.getReaders();
      const readers = readersResponse.data.readers || [];
      const primaryReader = readers.find(r => r.isPrimary) || readers[0];
      
      if (primaryReader) {
        const profileResponse = await gamificationApi.getReaderProfile(primaryReader.id);
        setUserStats(profileResponse.data.profile);
      }
    } catch (error) {
      console.error('Error loading user stats:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        {isAuthenticated && preferences?.competitiveMode && userStats && (
          <div className="footer-stats">
            <span className="footer-stat">
              <span className="footer-stat-label">Chapters this season:</span>
              <span className="footer-stat-value">{userStats.stats?.seasonChaptersRead?.toLocaleString() || '0'}</span>
            </span>
            <span className="footer-stat">
              <span className="footer-stat-label">Bibles completed:</span>
              <span className="footer-stat-value">{userStats.stats?.completedBibles || '0'}</span>
            </span>
          </div>
        )}

        <div className="footer-copyright">
          <div className="footer-brand">
            <img src="/logo.jpeg" alt="ReadTheWord Logo" className="footer-logo" />
            <p className="footer-text">
              &copy; 2025 ReadTheWord
            </p>
          </div>
          <div className="footer-links">
            {isAuthenticated && preferences?.competitiveMode && (
              <Link to="/leaderboard" className="footer-nav-link">
                🏆 Leaderboard
              </Link>
            )}
            <Link to="/privacy" className="footer-link">
              Privacy Policy
            </Link>
            <a 
              href="https://saltmarshdigital.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-link"
            >
              Powered by Saltmarsh Digital
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
